import { GoPerson } from 'react-icons/go';
import { GiGearStickPattern } from 'react-icons/gi';
import { BsFillFuelPumpFill } from 'react-icons/bs';
import clsx from 'clsx';
import { VEHICLE_BY_SLUG_QUERYResult } from 'sanity.types';

type SpecsType =
    NonNullable<VEHICLE_BY_SLUG_QUERYResult>['vehicleSpecifications'];

interface VehicleSpecificationsProps {
    vehicleSpecifications: SpecsType | null | undefined;
    small?: boolean;
    className?: string;
}

const VehicleSpecifications = ({
    vehicleSpecifications,
    small = false,
    className,
}: VehicleSpecificationsProps) => {
    if (!vehicleSpecifications) return null;

    const { transmissionType, fuelType, vehicleNumberSeats } =
        vehicleSpecifications;

    const fuelTypesMap = {
        diesel: 'Diesel',
        electric: 'Electric',
        hybrid: 'Hybrid',
        petrol: 'Petrol',
        lpg: 'LPG',
        selfChargingHybrid: 'Self Charging Hybrid',
        plugInHybrid: 'Plug-in Hybrid',
    };

    const containerClasses = clsx(
        'flex',
        'flex-wrap',
        'items-start',
        'justify-around',
        className ? className : ''
    );

    const iconSize = small ? 16 : 22;

    const iconClasses = clsx(
        'flex',
        'flex-row',
        small ? 'text-xs' : 'text-sm',
        'items-center',
        'font-bold',
        'mb-2'
    );

    return (
        <div className={containerClasses}>
            <div className={iconClasses}>
                <GoPerson size={iconSize} className="mr-2" />{' '}
                {vehicleNumberSeats}
            </div>
            <div className={iconClasses}>
                <GiGearStickPattern size={iconSize} className="mr-2" />{' '}
                {transmissionType}
            </div>
            <div className={`${iconClasses} whitespace-nowrap`}>
                <BsFillFuelPumpFill size={iconSize} className="mr-2" />{' '}
                {fuelTypesMap[fuelType as keyof typeof fuelTypesMap]}
            </div>
        </div>
    );
};

export default VehicleSpecifications;
